import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { LoadingIndicatorMessages as messages } from './LoadingIndicator.i18n';

export class LoadingIndicator extends React.Component {
  constructor() {
    super();
    this.state = {
      isShowIndicator: false,
      timerId: null,
    };
  }

  componentDidMount = () => {
    const timerId = setTimeout(() => this.setState({ isShowIndicator: true }), 500);
    this.setState({ timerId });
  }

  componentWillUnmount = () => {
    clearTimeout(this.state.timerId);
  }

  render = () => {
    if (!this.state.isShowIndicator) {
      return null;
    }
    const outerWrapperClass = this.props.size === 'small' ? 'loading-outer-wrapper-small' : 'loading-outer-wrapper';
    return (
      <div className={ outerWrapperClass }>
        <div className="loading-mid-container ">
          <div className="loading-content">
            <div className="loader"></div>
            <div className="loading-message">
              <FormattedMessage {...messages.message} />
            </div>
          </div>
        </div>
      </div>);
  }
}

LoadingIndicator.propTypes = {
  size: PropTypes.string,
};
